import FeedbackModule from "@/components/FeedbackModule";

const COMMANDER_MODULES = [
    {
        key: "operational_friction",
        label: "Operational Friction",
        fields: ["title", "rating", "body"],
        placeholder: "What's slowing the pour-line down? Inventory, supply, UI…",
    },
    {
        key: "niche_suggestion",
        label: "Niche Suggestions",
        fields: ["title", "body"],
        placeholder: "A new niche worth scouting? Pet wellness? Outdoor?",
    },
    {
        key: "dry_dock_waiver",
        label: "Dry-Dock Waiver",
        fields: ["title", "body"],
        placeholder: "Context to attach to a Dry-Dock Waiver request…",
    },
];

export default function CommandersLog() {
    return (
        <div data-testid="commanders-log">
            <FeedbackModule
                channel="commander"
                kicker="Commander's Log · Director's Desk"
                title="Log the friction."
                helper="Operational signals routed straight to Director K. and the EIGOO crew. Tagged · commander."
                modules={COMMANDER_MODULES}
                testIdPrefix="commander-feedback"
                palette={{
                    bg: "var(--ig-cream-warm)",
                    ink: "var(--ig-forest)",
                    accent: "var(--ig-gold)",
                    panel: "var(--ig-cream-warm)",
                }}
            />
        </div>
    );
}
